// src/components/CustomButton.tsx
import React from 'react';
import { ButtonProps, } from '@mui/material';
import { useSelector } from "react-redux";
import { RootState } from "../stores";
import { StyledButton } from './styles/CustomButton.styles';

interface CustomButtonProps extends ButtonProps {
  children: React.ReactNode;
}

const CustomButton: React.FC<CustomButtonProps> = (props) => {
  const isLoading = useSelector((state: RootState) => state.loading.activeRequests > 0);
  const { type = 'button' } = props
  return (
    <StyledButton disabled={isLoading && type === 'submit'} {...props}>
      {/* {isLoading && type === 'submit' ? <CircularProgress size={24} color="inherit" /> : props.children} */}
      {props.children}
    </StyledButton>
  );
};
export default CustomButton;
